export const API_ENDPOINT = "https://api.redmorus.com/";
export const ENVIROMENT = "production";
export const VERSION = "1.1.1";

console.log(process.env.NODE_ENV);

